import React from 'react';
import { usePhrMobileStoreInContext } from '@/stores/phrMobile';
import { useNavigate } from 'react-router-dom';
import PHRMobileIndex from '../PHRMobileScreen/PHRMobileIndex';
import useGlobalMobileConfigs from '@/stores/globalConfigsMobile';
import SurvivalIndex from './SurvivalIndex';
import { TYPE_POST_MESSAGE } from '@/hooks/useMessageWebview';
import utils from '@/utils';
import WrapRefresh from '../components/WrapRefresh';

const PHRMobileDetail = () => {
  const navigate = useNavigate();
  const user = usePhrMobileStoreInContext((s) => s.user);
  const components = usePhrMobileStoreInContext((s) => s.phr?.components);
  const emrTypes = useGlobalMobileConfigs((s) => s.emrTypes);
  const serviceInfo = useGlobalMobileConfigs((s) => s.phrConfigs?.serviceInfo);
  const bodyIndex = useGlobalMobileConfigs((s) => s.phrConfigs?.bodyIndex);

  const refetchPhr = usePhrMobileStoreInContext((s) => s.refetchPhr);
  const getConfigs = useGlobalMobileConfigs((s) => s.getConfigs);

  const healthsIndex = components?.reduce((d: any, e: IEMRData) => {
    d[e.type.code] = e;
    return d;
  }, {});

  const onBooking = () => {
    utils.postMessage({
      type: TYPE_POST_MESSAGE.EMR_BOOKING,
      data: {
        uid: user?._id,
        patientId: user?.id,
      },
    });
  };

  const onRefresh = () => {
    getConfigs?.();
    refetchPhr?.();
  };

  return (
    <WrapRefresh onRefresh={onRefresh} refreshColor={'white'}>
      <div
        className="overflow-auto h-full"
        style={{ background: 'linear-gradient(180deg, #37D2D2 0% 50%, #fafafa 50% 100%)' }}
      >
        {/* Header */}
        <div className=" bg-mint-9 pb-4 pt-2">
          <PHRMobileIndex
            navigate={navigate}
            user={user}
            healthsIndex={healthsIndex}
            bodyIndex={bodyIndex}
            from="detail"
            onDetail={() => navigate(`/phr-mobile/detail/${user?._id ?? 'error/error'}`)}
          />
        </div>
        <div className="flex flex-col flex-grow pt-4 bg-gray-2">
          <SurvivalIndex
            navigate={navigate}
            serviceInfo={serviceInfo}
            healthsIndex={healthsIndex}
            emrTypes={emrTypes}
            user={user}
          />
        </div>
      </div>
      <div className="sticky left-0 right-0 bottom-0 bg-white pt-4 pb-4 justify-center flex border-t-2 border-t-gray-4">
        <button onClick={onBooking} className="h-9 w-40 bg-gradient-1 rounded-full justify-center items-center">
          <span className="text-white pl-2 cms-h5">Hẹn tư vấn</span>
        </button>
      </div>
    </WrapRefresh>
  );
};

export default PHRMobileDetail;
